<template>
    <div class="chart">
        <h4 class="ps-2 text-primary mb-0" @click="foldChartFunction()">
            <span class="d-none d-sm-inline">Behandlingar senaste 12 månaderna</span>
            <span class="d-sm-none">Behandlingar senaste 12 mån</span>
            <div class="fold-arrow float-end" :class="{ 'folded' : foldChart == 1 }"><img class="arrow-icon" src="/images/company-portal/icon-arrow.svg"></div></h4>
        <div class="w-100 pt-8" v-if="foldChart == 1">
            <highcharts :options="chartOptions"></highcharts>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        fetcher
    ],

    data () {
        return {
            cart_data: null,
            fetcher: {
                autoFill: [
                    'cart_data'
                ]
            },

            foldChart: 1,
            chartOptions: {
                chart: {
                    type: 'spline',
                    height: 340
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                legend:
                    {
                        enabled: false
                    },
                xAxis: {
                    categories: [],
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    gridLineWidth: 1,
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                plotOptions:
                    {
                        spline:
                            {
                                lineWidth: 3,
                                marker: {
                                    radius: 5
                                }
                            }
                    },
                colors: ['#00a870'],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 576
                        },
                        // Make the labels less space demanding on mobile
                        chartOptions: {
                            xAxis: {
                                labels: {
                                    style: {
                                        fontSize: '11px'
                                    }
                                }
                            },
                            yAxis: {
                                labels: {
                                    style: {
                                        fontSize: '11px'
                                    }
                                }
                            }
                        }
                    }]
                },
                series: [{
                    name: 'Behandlingar',
                    data: []
                }]
            }
        }
    },

    mounted () {
        this.foldChart = Cookies.get('foldChart')
    },

    computed: {
        fetcherUrl () {
            return '/data/treatments/chart'
        }
    },

    methods: {

        foldChartFunction () {
            if (this.foldChart === 1) {
                this.foldChart = 0
            } else {
                this.foldChart = 1
            }

            Cookies.set('foldChart', this.foldChart)
        },

        fetcherSuccess (data) {
            this.chartOptions.xAxis.categories = data.dates
            this.chartOptions.series[0].data = data.num_treatments
        }

    }

}
</script>
